import { ReactNode } from 'react';
import { type I18nLocale, t } from '@ardoq/i18n';
import { Paragraph } from '@ardoq/typography';
import { Box } from '@ardoq/layout';

const getPreviewingRowsLabel = (
  i18nLocale: I18nLocale,
  rowCount: number
): string => {
  if (rowCount === 1) {
    return t(
      i18nLocale,
      'integrations:previewingRows.full_one',
      { total: rowCount },
      'Previewing {{total}} row'
    );
  }
  return t(
    i18nLocale,
    'integrations:previewingRows.full',
    { total: rowCount },
    'Previewing {{total}} rows'
  );
};

export const PreviewingRows = ({
  rowCount,
  i18nLocale,
}: {
  rowCount: number;
  i18nLocale: I18nLocale;
}): ReactNode => (
  <Box role="status">
    <Paragraph variant="caption" color="textSubtle">
      {getPreviewingRowsLabel(i18nLocale, rowCount)}
    </Paragraph>
  </Box>
);
